import React from "react";
import { View, Text } from "react-native";
import MaterialIcons from "react-native-vector-icons/MaterialIcons";
import LhButton from "../../../components/LhButton";
import { Platform, Dimensions } from "react-native";
import { isIOSMobile } from '../../sparcwalk/utils/deviceDetection';
import { useTheme } from "../../../theme";

interface WelcomeContainerProps {
  onBeginClick: () => void;
  isMobileView: boolean;
  styles: any;
}

const isIPad = () => Platform.OS === "ios" && Dimensions.get("window").width >= 768;

const WelcomeContainer: React.FC<WelcomeContainerProps> = ({
  onBeginClick,
  isMobileView,
  styles,
}) => {
  const { colors, resolvedTheme } = useTheme();
  const isDark = resolvedTheme === "dark";
  // Determine platform-specific font sizing
  const isWeb = Platform.OS === 'web';
  const isIOS = Platform.OS === 'ios';
  const welcomeFontStyle = isWeb ? { fontSize: 28 } : isIOS ? { fontSize: 24 } : {};

  return (
    <View style={styles.welcomeCard}>
      <View style={styles.welcomeContainer}>
        <View style={styles.welcomeLeftContent}>
          <Text style={[styles.welcomeText, welcomeFontStyle, isDark && { color: colors.text.primary }]}>Site Evaluation</Text>
        </View>
        <View
          style={
            isMobileView ? styles.beginButtonRowMobile : styles.beginButtonRow
          }
        >
          <LhButton
            text={isIPad() ? "New Evaluation" : isMobileView ? "Begin" : "New Evaluation"}
            variant="primary"
            size="small"
            iconTrailing={isIPad() ? "" : isMobileView ? "arrow-forward" : ""}
            iconSize={20}
            onPress={onBeginClick}
            isLoading={false}
            disabled={false}
            style={{
              ...styles.beginButton,
              backgroundColor: '#034895',
              // Reduced widths for mobile so the button is smaller on phones
              ...(isMobileView && !isIPad() ? { minWidth: 90, maxWidth: 100, paddingHorizontal: 2 } : {})
            }}
          />
        </View>
      </View>
    </View>
  );
};

export default WelcomeContainer;
